import { render } from "./Estudiante.vue?vue&type=template&id=8a366f76&scoped=true"
import script from "./Estudiante.vue?vue&type=script&lang=js"
export * from "./Estudiante.vue?vue&type=script&lang=js"

import "./Estudiante.vue?vue&type=style&index=0&id=8a366f76&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a366f76"]])

export default __exports__